import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=64b5ace5&"
import script from "./FilesList.vue?vue&type=script&lang=js&"
export * from "./FilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilesList.vue"
export default component.exports